import { useContext } from "react";
import { RequestExperienceContext } from "./RequestExperienceContext";

const useRequestExperienceContext = () => useContext(RequestExperienceContext);

export default useRequestExperienceContext;
